import { Component, OnInit, Inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PlanoAcaoService } from "./../../../services/plano-acao.service";
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { IAcaoPlanoAcaoModel, IAcaoPlanoAcaoRecomendacaoModel, IPlanoAcaoRelatoriaModel } from '../../../models/plano-acao-model';
import { sobreporAvaliacaoMaisRecente } from '../../../shared/util/plano-acao-historico-abas';

interface IMonitor {
  responsavelNomeMonitoramento: string;
  responsavelCargoMonitoramento: string;
}

@Component({
  selector: 'app-plano-acao-monitor-imprimir-relatoria',
  templateUrl: './plano-acao-monitor-imprimir-relatoria.component.html',
  styleUrls: ['./plano-acao-monitor-imprimir-relatoria.component.scss']
})
export class PlanoAcaoMonitorImprimirRelatoriaComponent implements OnInit {

  public model: IPlanoAcaoRelatoriaModel = {} as IPlanoAcaoRelatoriaModel;
  public id: number = 0;
  public dataHoje: Date = this.truncateDate(new Date());
  public dataExecucao: Date = this.truncateDate(new Date());
  public minuta: boolean = false;
  public monitores: IMonitor[] = [];

  public relevanciaMuitoBaixaQtde: number = 0;
  public relevanciaBaixaQtde: number = 0;
  public relevanciaModeradaQtde: number = 0;
  public relevanciaAltaQtde: number = 0;
  public relevanciaMuitoAltaQtde: number = 0;

  public statusAtendidaQtde: number = 0;
  public statusAtendidaParcialmenteQtde: number = 0;
  public statusNaoAtendidaQtde: number = 0;
  public statusPendenteAcaoControleQtde: number = 0;
  public statusASerRealizadaQtde: number = 0;
  public statusEmExecucaoQtde: number = 0;
  public statusConcluidaQtde: number = 0;

  constructor(
    public matDialog: MatDialog,
    public route: ActivatedRoute,
    private planoAcaoService: PlanoAcaoService,
    private dialogRef: MatDialogRef<PlanoAcaoMonitorImprimirRelatoriaComponent>,
    @Inject(MAT_DIALOG_DATA) public data) {
    this.id = data?.id;
  }

  ngOnInit(): void {
    // Demanda 68742 linha 41: snapshot de versão dispensa nova consulta.
    if (this.data?.snapshot) {
      this.aplicarSnapshot(this.data.snapshot);
      this.complementarAvaliacaoMaisRecente();
      return;
    }
    this.getImprimirPlanoAcaoRelatoria(this.id);
  }

  private complementarAvaliacaoMaisRecente(): void {
    sobreporAvaliacaoMaisRecente(this.model?.acoes || [], (id) => this.planoAcaoService.obterHistoricoAcao(id))
      .then(() => {
        this.monitores = this.getMonitores(
          (this.model.acoes || []).filter(a => a.responsavelNomeMonitoramento)
        );
      });
  }

  private aplicarSnapshot(snapshot: IPlanoAcaoRelatoriaModel): void {
    this.model = snapshot;
    this.relevanciaMuitoBaixaQtde = snapshot.resumoPorRelevancia?.find(x => x.nivelRelevancia.codigo === 1)?.qtde ?? 0;
    this.relevanciaBaixaQtde = snapshot.resumoPorRelevancia?.find(x => x.nivelRelevancia.codigo === 2)?.qtde ?? 0;
    this.relevanciaModeradaQtde = snapshot.resumoPorRelevancia?.find(x => x.nivelRelevancia.codigo === 3)?.qtde ?? 0;
    this.relevanciaAltaQtde = snapshot.resumoPorRelevancia?.find(x => x.nivelRelevancia.codigo === 4)?.qtde ?? 0;
    this.relevanciaMuitoAltaQtde = snapshot.resumoPorRelevancia?.find(x => x.nivelRelevancia.codigo === 5)?.qtde ?? 0;

    this.statusAtendidaQtde = snapshot.resumoPorStatus?.find(x => x.status.codigo === 9)?.qtde ?? 0;
    this.statusAtendidaParcialmenteQtde = snapshot.resumoPorStatus?.find(x => x.status.codigo === 10)?.qtde ?? 0;
    this.statusNaoAtendidaQtde = snapshot.resumoPorStatus?.find(x => x.status.codigo === 11)?.qtde ?? 0;
    this.statusPendenteAcaoControleQtde = snapshot.resumoPorStatus?.find(x => x.status.codigo === 12)?.qtde ?? 0;
    this.statusASerRealizadaQtde = snapshot.resumoPorStatus?.find(x => x.status.codigo === 6)?.qtde ?? 0;
    this.statusEmExecucaoQtde = snapshot.resumoPorStatus?.find(x => x.status.codigo === 7)?.qtde ?? 0;
    this.statusConcluidaQtde = snapshot.resumoPorStatus?.find(x => x.status.codigo === 8)?.qtde ?? 0;

    this.monitores = this.getMonitores(
      (this.model.acoes || []).filter(a =>
        a.responsavelNomeMonitoramento
      )
    );
  }

  getImprimirPlanoAcaoRelatoria(Id: number) {

    this.planoAcaoService
      .imprimirRelatoriaPorId(this.id)
      .then((res) => {
        this.model = res.dados;

        this.relevanciaMuitoBaixaQtde = res.dados.resumoPorRelevancia.find(x => x.nivelRelevancia.codigo === 1)?.qtde ?? 0;
        this.relevanciaBaixaQtde = res.dados.resumoPorRelevancia.find(x => x.nivelRelevancia.codigo === 2)?.qtde ?? 0;
        this.relevanciaModeradaQtde = res.dados.resumoPorRelevancia.find(x => x.nivelRelevancia.codigo === 3)?.qtde ?? 0;
        this.relevanciaAltaQtde = res.dados.resumoPorRelevancia.find(x => x.nivelRelevancia.codigo === 4)?.qtde ?? 0;
        this.relevanciaMuitoAltaQtde = res.dados.resumoPorRelevancia.find(x => x.nivelRelevancia.codigo === 5)?.qtde ?? 0;

        this.statusAtendidaQtde = res.dados.resumoPorStatus.find(x => x.status.codigo === 9)?.qtde ?? 0;
        this.statusAtendidaParcialmenteQtde = res.dados.resumoPorStatus.find(x => x.status.codigo === 10)?.qtde ?? 0;
        this.statusNaoAtendidaQtde = res.dados.resumoPorStatus.find(x => x.status.codigo === 11)?.qtde ?? 0;
        this.statusPendenteAcaoControleQtde = res.dados.resumoPorStatus.find(x => x.status.codigo === 12)?.qtde ?? 0;
        this.statusASerRealizadaQtde = res.dados.resumoPorStatus.find(x => x.status.codigo === 6)?.qtde ?? 0;
        this.statusEmExecucaoQtde = res.dados.resumoPorStatus.find(x => x.status.codigo === 7)?.qtde ?? 0;
        this.statusConcluidaQtde = res.dados.resumoPorStatus.find(x => x.status.codigo === 8)?.qtde ?? 0;

        this.monitores = this.getMonitores(
          (this.model.acoes || []).filter(a =>
            a.responsavelNomeMonitoramento
          )
        );
        this.complementarAvaliacaoMaisRecente();
      })
      .catch((err) => {
      })
  }

  onImprimir() {
    // opcional — pode deixar vazio, o print já é interno
  }

  onFechar() {
    this.dialogRef.close();
  }

  private truncateDate(date: Date): Date {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
  }

  getRowSpanAcao(item: IAcaoPlanoAcaoModel): number {
    if (!item.recomendacoes || item.recomendacoes.length === 0) {
      return 1;
    }

    let total = 0;

    item.recomendacoes.forEach((r: IAcaoPlanoAcaoRecomendacaoModel) => {
      if (r.recomendacao.itensVinculados && r.recomendacao.itensVinculados.length > 0) {
        total += r.recomendacao.itensVinculados.length;
      } else {
        total += 1;
      }
    });

    return total;
  }

  getRowSpanRecomendacao(r: any): number {
    const qtd = r.recomendacao?.itensVinculados?.length;
    return qtd && qtd > 0 ? qtd : 1;
  }

  getMonitores(acoes: IAcaoPlanoAcaoModel[]): IMonitor[] {
    const map = new Map<string, IMonitor>();

    acoes.forEach(a => {
      if (!a.responsavelNomeMonitoramento) return;

      const key = `${a.responsavelNomeMonitoramento}-${a.responsavelCargoMonitoramento}`;

      if (!map.has(key)) {
        map.set(key, {
          responsavelNomeMonitoramento: a.responsavelNomeMonitoramento,
          responsavelCargoMonitoramento: a.responsavelCargoMonitoramento
        });
      }
    });

    return Array.from(map.values());
  }

  getClasseAvaliacao(avaliacao: number | undefined): string {

    switch (avaliacao) {
      case 1: return 'avaliacao-ImplementadoTotalmente';
      case 2: return 'avaliacao-AltoNivelImplementacao';
      case 3: return 'avaliacao-ModeradoNivelImplementacao';
      case 4: return 'avaliacao-BaixoNivelImplementação';
      case 5: return 'avaliacao-NaoImplementado';
      default: return 'avaliacao-NaoImplementado';
    }
  }

}

